import actionTypes from '../../utilities/actionTypes';

export interface IFetchUsersSuccess {
  type: actionTypes.FETCH_USERS_SUCCESS;
  payload: any;
}
export interface IFetchUsers {
  type: actionTypes.FETCH_USERS;
}

export interface IFetchUsersPending {
  type: actionTypes.FETCH_USERS_PENDING;
}

export interface IDeleteUser {
  type: actionTypes.DELETE_USER;
  userId: string;
}

export interface IDeleteUserSuccess {
  type: actionTypes.DELETE_USER_SUCCESS;
  userId: string;
}

export interface IAddUserSuccess {
  type: actionTypes.ADD_USER_SUCCESS;
  payload: any;
}
export interface IAddUser {
  type: actionTypes.ADD_USER;
  payload: any;
}

export interface IUpdateUser {
  type: actionTypes.UPDATE_USER;
  payload: any;
}

export interface IUpdateUserSuccess {
  type: actionTypes.UPDATE_USER_SUCCESS;
  payload: any;
}

export interface IAuthSuccess {
  type: actionTypes.AUTH_SUCCESS;
  payload: any;
  token: string;
}

export interface ILogin {
  type: actionTypes.LOGIN;
  payload: any;
}

export interface IBasicLogin {
  type: actionTypes.BASIC_LOGIN;
  payload: any;
}
export interface ILogout {
  type: actionTypes.LOGOUT;
}
export interface IAuthLogout {
  type: actionTypes.AUTH_LOGOUT;
}

export interface IAuthCheckState {
  type: actionTypes.AUTH_CHECK;
}

export interface IUpdateUserFailed {
  type: actionTypes.UPDATE_USER_FAILED;
}
export interface IUpdateUserChallengeAndSession {
  type: actionTypes.UPDATE_USER_CHALLENGE_AND_SESSION;
  payload: any;
}

export interface IChangePassword {
  type: actionTypes.CHANGE_PASSWORD;
  payload: any;
}
export interface IChangePasswordSuccess {
  type: actionTypes.CHANGE_PASSWORD_SUCCESS;
  payload: any;
}
export interface IForgotPassword {
  type: actionTypes.FORGOT_PASSWORD;
  payload: { email: string };
}
export interface ISetPassword {
  type: actionTypes.SET_PASSWORD;
  payload: { email: string; confirmationCOde: string; new_password: string };
}

export const fetchUsersSuccess = (payload: any): IFetchUsersSuccess => {
  return {
    type: actionTypes.FETCH_USERS_SUCCESS,
    payload
  };
};
export const fetchUsers = (): IFetchUsers => {
  return {
    type: actionTypes.FETCH_USERS
  };
};

export const deleteUserSuccess = (userId: string): IDeleteUserSuccess => {
  return {
    type: actionTypes.DELETE_USER_SUCCESS,
    userId
  };
};

export const authSuccess = (payload: any, token: string): IAuthSuccess => {
  return {
    type: actionTypes.AUTH_SUCCESS,
    payload,
    token
  };
};

export const authLogout = (): IAuthLogout => {
  return {
    type: actionTypes.AUTH_LOGOUT
  };
};
export const deleteUser = (userId: any): IDeleteUser => {
  return {
    type: actionTypes.DELETE_USER,
    userId
  };
};

export const login = (payload): ILogin => {
  return {
    type: actionTypes.LOGIN,
    payload
  };
};
export const basicLogin = (payload): IBasicLogin => {
  return {
    type: actionTypes.BASIC_LOGIN,
    payload
  };
};

export const logout = (): ILogout => {
  return {
    type: actionTypes.LOGOUT
  };
};

export const addUserSuccess = (payload: any): IAddUserSuccess => {
  return {
    type: actionTypes.ADD_USER_SUCCESS,
    payload
  };
};
export const addUser = (payload: any): IAddUser => {
  return {
    type: actionTypes.ADD_USER,
    payload
  };
};

export const updateUserSuccess = (payload: any): IUpdateUserSuccess => {
  return {
    type: actionTypes.UPDATE_USER_SUCCESS,
    payload
  };
};
export const updateUserFailed = (): IUpdateUserFailed => {
  return {
    type: actionTypes.UPDATE_USER_FAILED
  };
};
export const updateUser = (payload: any): IUpdateUser => {
  return {
    type: actionTypes.UPDATE_USER,
    payload
  };
};

export const updateUserChallengeAndSession = (
  payload: any
): IUpdateUserChallengeAndSession => {
  return {
    type: actionTypes.UPDATE_USER_CHALLENGE_AND_SESSION,
    payload
  };
};

export const changePassword = (payload: any): IChangePassword => {
  return {
    type: actionTypes.CHANGE_PASSWORD,
    payload
  };
};

export const changePasswordSuccess = (payload: any): IChangePasswordSuccess => {
  return {
    type: actionTypes.CHANGE_PASSWORD_SUCCESS,
    payload
  };
};

export const authCheckState = (): IAuthCheckState => {
  return {
    type: actionTypes.AUTH_CHECK
  };
};

export const forgotPassword = (payload): IForgotPassword => {
  return {
    type: actionTypes.FORGOT_PASSWORD,
    payload
  };
};

export const setPassword = (payload): ISetPassword => {
  return {
    type: actionTypes.SET_PASSWORD,
    payload
  };
};

export type IUserAction =
  | IFetchUsersSuccess
  | IFetchUsersPending
  | IAuthSuccess
  | IAuthLogout
  | IDeleteUserSuccess
  | IAddUserSuccess
  | IUpdateUserSuccess
  | IDeleteUser
  | ILogin
  | IBasicLogin
  | ILogout
  | IFetchUsers
  | IAddUser
  | IUpdateUser
  | IUpdateUserFailed
  | IUpdateUserChallengeAndSession
  | IChangePassword
  | IChangePasswordSuccess
  | ISetPassword
  | IForgotPassword;
